/* @flow */

import type { ReadOnlyKeyValuePair } from '../../jsHelpers/types';

export const AVENUE_ID: ReadOnlyKeyValuePair<string> = Object.freeze({
  Explore: 'explore_avenue_id',
  MyVideos: 'mylists_avenue_id',
});
